function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconReEnergyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4c-1.048 0-2.152.096-3.137.365l-.526-1.93C13.552 2.104 14.847 2 16 2c6.575 0 12.273 4.73 13.675 10.878l-1.95.444C26.527 8.07 21.625 4 16 4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 12.8L29 16l1.5-3.7-3.9.5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56 21.99C2.71 17.112 3.811 10.925 7.781 7.232L6.419 5.768C1.79 10.074.49 17.284 3.837 23.005l.005.01a14.95 14.95 0 002.25 2.892l1.415-1.414A12.949 12.949 0 015.56 21.99z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.4l1.5-3.7-3.9.6L8 8.4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.468 21.945c.512-.769.878-1.75 1.167-2.808l1.93.526c-.31 1.132-.739 2.341-1.417 3.367-3.339 5.682-10.212 8.264-16.254 6.322l.612-1.904c5.148 1.655 11.065-.553 13.93-5.453l.015-.025.017-.025z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 26.7l-4 .5 2.4 3.2 1.6-3.7z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.104 14.721l.854-3.2-4.127 3.409 4.527 1.886-.932 3.725 4.677-3.897-4.999-1.923zm8.101.973a.5.5 0 01.14.851L13.178 25.02a.5.5 0 01-.806-.505L14 18l-5.235-2.181a.5.5 0 01-.126-.847l9.657-7.977a.5.5 0 01.802.514L17.5 13.5l5.705 2.194z",
    fill: props.color
  }));
}

export default SvgIconReEnergyFilled;